'use client'
import React from 'react'
import NextTopLoader from 'nextjs-toploader'

export default function TopLoaderProgressBar() {
  return (
    <NextTopLoader
      color="#2299DD"
      initialPosition={0.08}
      crawlSpeed={400}
      height={3}
      crawl={true}
      showSpinner={false}
      easing="ease"
      speed={200}
      shadow="0 0 10px #2299DD,0 0 5px #2299DD"
      template='<div class="bar a-pulse u-bg-blue" role="bar"><div class="peg"></div></div>'
      zIndex={1600}
      showAtBottom={false}
    />
  )
}
